import Cookies from '@/utils/cookie-provider'

const LIVE_DEBUG_KEY = '__gbd_l__'

const isDebugging = () => !!Cookies.get(LIVE_DEBUG_KEY)
const setDebugging = () => Cookies.set(LIVE_DEBUG_KEY, '1')
const unsetDebugging = () => Cookies.remove(LIVE_DEBUG_KEY)

export { isDebugging, setDebugging, unsetDebugging }
